import { useEffect, useRef, useCallback } from 'react';
import { useMsal } from '@azure/msal-react';

const IDLE_TIMEOUT_MS =
  (Number(process.env.REACT_APP_IDLE_TIMEOUT_MINS) || 15) * 60 * 1000;

const ACTIVITY_EVENTS = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'];

const IdleTimer = ({ children }) => {
  const { instance } = useMsal();
  const timerRef = useRef(null);

  const logout = useCallback(() => {
    instance.logoutRedirect({
      postLogoutRedirectUri:
        process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URI || window.location.origin + '/',
    });
  }, [instance]);

  const resetTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      const accounts = instance.getAllAccounts();
      if (accounts.length > 0) {
        logout();
      }
    }, IDLE_TIMEOUT_MS);
  }, [instance, logout]);

  useEffect(() => {
    const onActivity = () => resetTimer();

    ACTIVITY_EVENTS.forEach((evt) => window.addEventListener(evt, onActivity));
    resetTimer();

    return () => {
      ACTIVITY_EVENTS.forEach((evt) => window.removeEventListener(evt, onActivity));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [resetTimer]);

  return children;
};

export default IdleTimer;
